export default __webpack_public_path__ + "static/media/JazPortfolioPic.e19f6480.png";